
import { format } from "date-fns";
import { mapGetters } from "vuex";
import { setAttributeToElements } from "~/utils";
export default {
  props: {
    article: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getSystemDateFormat: "general/getSystemDateFormat",
    }),
    createdAt() {
      const date = format(
        new Date(this.article.created_at),
        "dd MMMM yyyy"
      ).split(" ");
      return `<span>${date[0]}</span> ${date[1]} <br> ${date[2]}`;
    },
    image() {
      return this.article?.medias?.find((el) => el.position === "list") || "";
    },
  },
  mounted() {
    setAttributeToElements("a.hidden-ssr-link", "tabindex", "0");
  },
};
